import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M3 10.4h5v1.2H3zM9.176 5.8c-.415-.544-.592-1.317-.592-2.031 0-.603.145-2.569 2.007-2.569 1.849 0 1.993 1.967 1.993 2.569 0 .486-.11 1.122-.384 1.663v1.791c1.072-.711 1.584-2.111 1.584-3.453 0-2.291-1.253-3.77-3.193-3.77-1.948 0-3.207 1.479-3.207 3.769 0 .707.134 1.414.404 2.031h1.388zM16.31 10.844a3.647 3.647 0 0 0-.755-1.178 6.39 6.39 0 0 0-1.893-1.331l-.376-.175-.297.289a3.52 3.52 0 0 1-.789.566v1.322a4.665 4.665 0 0 0 1.301-.739c.451.249.851.552 1.192.903.21.216.38.482.504.791l1.014 2.508H12.2V15h5.79l-1.68-4.156z" />
    <path d="M0 18l3.009-3.008H11V7H0v11zm1.2-9.8h8.6v5.592H2.512L1.2 15.103V8.2z" />
  </svg>
);

export default SvgComponent;
